// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ClimateScenarioYear;
(function (ClimateScenarioYear) {
    ClimateScenarioYear["Today"] = "Today";
    ClimateScenarioYear["Year2050"] = "Year2050";
})(ClimateScenarioYear || (ClimateScenarioYear = {}));
export function ClimateScenarioYearFromJSON(json) {
    return json;
}
export function ClimateScenarioYearToJSON(value) {
    return value;
}
